import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Pressable, ScrollView, StyleSheet, TextInput as RNTextInput, View } from 'react-native';
import { ArrowIcon, Button as Button95, Hourglass, NumberInput, Panel, TextInput } from 'react95-native-rabbl';
import Head from 'expo-router/head';
import { CustomText, CustomTextStyles } from '@/components/CustomText';
import Footer from '@/components/Footer';
import * as AppUtilities from "@/utilities/AppUtilities";
import * as AppUtils from '@/utilities/AppUtils';
import * as AppConstants from "@/utilities/AppConstants";
import { useForm, Controller } from "react-hook-form";
import { AppContext } from '@/components/AppContext';
import { RelativePathString, useRouter } from 'expo-router';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { setData } from '@/state/user';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    paddingTop: 10,
    gap: 20,
    backgroundColor: 'transparent',
    alignItems: 'center',
  },
  formElement: {
    width: '100%',
  },
  inputWrapper: {
    gap: 10,
    alignItems: 'center',
    width: '100%',
  },
  buttonWrapper: {
    flexDirection: 'row',
  },
  panel: {
    padding: 20,
    gap: 20,
    alignItems: 'center',
  },
  numericWrapper: {
    flexDirection: 'row',
    gap: 5,
  },
  numeric: {
    width: 80,
  },
  textWrapper: {
    flexDirection: 'row',
    alignSelf: 'center',
    paddingTop: 20,
  }
});

export default function CancelCreate() {
  const { showSpinner, hideSpinner } = useContext(AppContext);
  const router = useRouter();
  const dispatch = useDispatch();

  async function onSubmit() {
    try {
      showSpinner();

      const response = await AppUtilities.fetchAuthorized(
        "CancelCreate.onSubmit",
        "/rabbl/api/cancelcreate",
        "POST",
        {
        }
      );
      dispatch(setData(response));
      router.replace("/rabbls");

    } catch (e) {
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => onSubmit(), true);
      AppUtilities.handleException(e, "CancelCreate.onSubmit");
    } finally {
      hideSpinner();
    }
  };

  return (
    <View style={styles.textWrapper}>
      <Pressable
        onPress={
          () => AppUtils.showDialog(
                  "Cancel creating this Rabbl?",
                  onSubmit,
                  "Cancel Rabbl",
                  "Nevermind",
                )
        }
      >
        <CustomText type="link">cancel</CustomText>
      </Pressable>
    </View>
  );
}
